import styled from "styled-components";


export const Layout = styled.div`
  font-size: 14px;
  min-height: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const Form = styled.div`
    width: 100%;
`
export const Row = styled.div`
  display: flex;
  flex-flow: row wrap;
  min-width: 0;
  margin: 16px 0 7px;
`;
export const Col = styled.div<{
    span: number;
    offset?: number;
}>`
  position: relative;
  min-height: 1px;

  display: block;
  flex: 0 0 ${props => props.span / 24 * 100}%;
  max-width: ${props => props.span / 24 * 100}%;

  ${props => props.offset ? `
    margin-left: ${props.offset/ 24 * 100}%;
  ` : null}
  
`;
export const Subject = styled.span`    
  font-size: 15px;
  color: #000;
  
`;
export const Extra = styled.span`
  color: #afafaf;
  margin-left: 10px;
`


export const Money = styled.span`
  color: #fc8321;
  font-size: 18px;
  line-height: 1;
`
export const MoneyUnit = styled.span`
    font-size: 14px;
`

export const QRCodeContainer = styled.div`
    position: relative;
    //padding: 7px;
    width: 160px;
    height: 160px;
    //background: #fff;
    //border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Overlay = styled.div`
`;
export const Placeholder = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #f55
`;
export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
`;

export const FormLabel = styled.label`
  width: 100%;
  display: block;
  color: #969696;
  text-align: right;
  padding-right: 10px;
`
